/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WidgetFunctionOperation } from '../../models/widget-function-operation';

export interface GetWidgetFunctionAndOperationsWithValue$Params {
  uwid?: number;
  arid?: number;
}

export function getWidgetFunctionAndOperationsWithValue(http: HttpClient, rootUrl: string, params?: GetWidgetFunctionAndOperationsWithValue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WidgetFunctionOperation>>> {
  const rb = new RequestBuilder(rootUrl, getWidgetFunctionAndOperationsWithValue.PATH, 'get');
  if (params) {
    rb.query('uwid', params.uwid, {});
    rb.query('arid', params.arid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WidgetFunctionOperation>>;
    })
  );
}

getWidgetFunctionAndOperationsWithValue.PATH = '/api/AclRole/widgetFunctionAndOperationsWithValue';
